module.exports = __webpack_public_path__ + "static/a-home-behind-the-lens-hero-1920x1080-4790833f8b661ecfbba9c835fef29427.jpg";